import type { LucideIcon } from 'lucide-react'
import * as React from 'react'
import { forwardRef } from 'react'

export const IdeaIcon: LucideIcon = forwardRef(({ size = 24, color = 'currentColor', ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M13.6855 20.3797H9.53213C9.15339 20.3797 8.84815 20.0722 8.84815 19.6957V19.215C8.85265 18.8017 8.8324 18.5115 8.7889 18.3495C8.55566 17.4952 7.93843 16.779 7.3407 16.0845C7.14345 15.8572 6.95746 15.6405 6.78646 15.4222C5.92624 14.328 5.46875 13.017 5.46875 11.6265C5.46875 8.23195 8.23167 5.47119 11.6261 5.47119C15.0197 5.47119 17.7819 8.23195 17.7819 11.6265C17.7819 13.0177 17.3267 14.3302 16.4642 15.4237C16.3134 15.6172 16.1394 15.8197 15.9579 16.0335C15.346 16.7535 14.6627 17.5567 14.4272 18.405C14.386 18.5565 14.3657 18.8287 14.3687 19.2097V19.6942C14.3687 20.0722 14.0635 20.3797 13.6855 20.3797ZM10.2176 19.0102H13.0015C13.009 18.4777 13.0608 18.2152 13.108 18.0442C13.4253 16.902 14.2112 15.9742 14.905 15.1597C15.0872 14.9452 15.247 14.7577 15.3887 14.5792C16.0584 13.7272 16.4132 12.708 16.4132 11.6272C16.4132 8.9872 14.2667 6.8392 11.6268 6.8392C8.9869 6.8392 6.83896 8.9872 6.83896 11.6272C6.83896 12.7057 7.19295 13.7257 7.86343 14.5777C8.02168 14.7802 8.19492 14.979 8.37867 15.1912C9.0109 15.9255 9.79463 16.8352 10.1111 17.991C10.1576 18.1717 10.2116 18.447 10.2176 19.0102Z'
        fill={color}
      />
      <path
        d='M13.685 22.191H9.53164C9.1529 22.191 8.84766 21.8843 8.84766 21.5055C8.84766 21.1275 9.1529 20.8223 9.53164 20.8223H13.685C14.063 20.8223 14.3682 21.1275 14.3682 21.5055C14.3682 21.8843 14.063 22.191 13.685 22.191Z'
        fill={color}
      />
      <path
        d='M12.6489 23.9999H10.5722C10.1935 23.9999 9.88672 23.6931 9.88672 23.3159C9.88672 22.9379 10.1935 22.6304 10.5722 22.6304H12.6489C13.0254 22.6304 13.3329 22.9379 13.3329 23.3159C13.3329 23.6931 13.0254 23.9999 12.6489 23.9999Z'
        fill={color}
      />
      <path
        d='M22.5698 12.3114H19.8339C19.4559 12.3114 19.1484 12.0061 19.1484 11.6274C19.1484 11.2494 19.4559 10.9434 19.8339 10.9434H22.5698C22.9478 10.9434 23.2531 11.2494 23.2531 11.6274C23.2531 12.0061 22.9478 12.3114 22.5698 12.3114Z'
        fill={color}
      />
      <path
        d='M3.4199 12.3114H0.68323C0.305241 12.3114 0 12.0061 0 11.6274C0 11.2494 0.305241 10.9434 0.68323 10.9434H3.41915C3.79714 10.9434 4.10463 11.2494 4.10463 11.6274C4.10538 12.0061 3.79789 12.3114 3.4199 12.3114Z'
        fill={color}
      />
      <path
        d='M11.6308 4.10551C11.2521 4.10551 10.9453 3.80026 10.9453 3.42151V0.684002C10.9453 0.306751 11.2521 0 11.6308 0C12.0095 0 12.3148 0.306751 12.3148 0.684002V3.42076C12.3148 3.79951 12.0095 4.10551 11.6308 4.10551Z'
        fill={color}
      />
      <path
        d='M19.3635 20.0499C19.1895 20.0499 19.0148 19.9831 18.8805 19.8489L16.9463 17.9138C16.6793 17.6476 16.6793 17.2133 16.9463 16.9456C17.2141 16.6786 17.6468 16.6801 17.9138 16.9471L19.848 18.8814C20.1157 19.1491 20.1157 19.5834 19.848 19.8504C19.7145 19.9846 19.5405 20.0499 19.3635 20.0499Z'
        fill={color}
      />
      <path
        d='M5.82111 6.5091C5.64712 6.5091 5.47162 6.44235 5.33663 6.3081L3.40393 4.37459C3.13619 4.10684 3.13619 3.67259 3.40393 3.40484C3.67167 3.13784 4.10441 3.13784 4.3714 3.40484L6.3056 5.3391C6.57334 5.6061 6.57334 6.0411 6.3056 6.3081C6.1721 6.44235 5.99736 6.5091 5.82111 6.5091Z'
        fill={color}
      />
      <path
        d='M3.88767 20.0501C3.71292 20.0501 3.53818 19.9849 3.40393 19.8506C3.13619 19.5836 3.13619 19.1494 3.40393 18.8816L5.33963 16.9459C5.60512 16.6789 6.03786 16.6789 6.3056 16.9459C6.57334 17.2136 6.57334 17.6479 6.3056 17.9156L4.3714 19.8506C4.23716 19.9841 4.06316 20.0501 3.88767 20.0501Z'
        fill={color}
      />
      <path
        d='M17.4297 6.50933C17.255 6.50933 17.0802 6.44258 16.9452 6.30833C16.6797 6.04133 16.6797 5.60782 16.9452 5.34082L18.8794 3.40657C19.1449 3.13957 19.5806 3.13807 19.8469 3.40507C20.1146 3.67282 20.1146 4.10557 19.8469 4.37332L17.9142 6.30683C17.7807 6.44108 17.6059 6.50933 17.4297 6.50933Z'
        fill={color}
      />
    </svg>
  )
})

IdeaIcon.displayName = 'IdeaIcon'
